import { SHOW_DIALOG, HIDE_DIALOG, CLOSE_ALL_DIALOGS } from "../Actions/ActionDialog";

const initialState = {
  dialogStack: [],
  content: null,
  size: 'large',
  isVisible: false,
  isOverlay: false
};

export const dialog = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_DIALOG:
      {
        const dialog = {
          content: action.content,
          size: action.size,
          isOverlay: action.isOverlay
        };
        const dialogStack = state.dialogStack.concat([dialog]);
        return Object.assign({}, state, dialog, {
          dialogStack: dialogStack,
          isVisible: true
        });
      }
    case HIDE_DIALOG:
      {
        const dialogStack = state.dialogStack.slice(0, state.dialogStack.length - 1);
        if (dialogStack.length) {
          const dialog = dialogStack[dialogStack.length - 1];
          return Object.assign({}, state, dialog, {
            dialogStack: dialogStack,
            isVisible: true
          });
        } else {
          return Object.assign({}, state, initialState);
        }
      }
    case CLOSE_ALL_DIALOGS:
      {
        return Object.assign({}, state, initialState);
      }
    default:
      return state;

  }
};